import {track as innerTrack} from '@stubhub/tracking-utils';

import {
  CHANGE_TRACK_NAME,
  CLICK_TRACK_NAME,
  CUSTOM_TRACK_NAME,
  PAGE_VIEW_TRACK_NAME,
  DATALAYER_WINDOW_KEY,
  TRACKING_INFO,
  SCREEN_VIEW,
  SIGN_UP,
  PURCHASE,
  BEGIN_CHECKOUT,
  VIEW_ITEM,
  VIEW_ITEM_LIST,
  LOGIN,
  ERROR,
} from './consts';
import beginCheckoutTemplate from './event-templates/begin_checkout';
import errorTemplate from './event-templates/error';
import loginTemplate from './event-templates/login';
import purchaseTemplate from './event-templates/purchase';
import screenViewTemplate from './event-templates/screen_view';
import signUpTemplate from './event-templates/sign_up';
import viewItemTemplate from './event-templates/view_item';
import viewItemListTemplate from './event-templates/view_item_list';

const CLIENT = typeof window !== 'undefined';

const pushDataToDataLayer = (data) => {
  if (CLIENT) {
    window[DATALAYER_WINDOW_KEY] = {...(window[DATALAYER_WINDOW_KEY] || {}), ...data};
  }
};

const clearDataOnDataLayer = (key) => {
  if (CLIENT) {
    const currentData = window[DATALAYER_WINDOW_KEY] || {};
    delete currentData[key];
    window[DATALAYER_WINDOW_KEY] = currentData;
  }
};

const satelliteTrack = (trackMethod, data) => {
  innerTrack(trackMethod, data);
};

const mappedSatelliteTrack = (trackMethod, template, data) => {
  if (Object.keys(data).every((r) => Object.keys(template).includes(r))) {
    // If any key in data is not included in template, we don't send the data
    satelliteTrack(trackMethod, {...template, ...data});
  }
};

const addEventListener = (event, func) => {
  if (CLIENT) {
    window.addEventListener(event, func);
  }
};

const removeEventListener = (event, func) => {
  if (CLIENT) {
    window.removeEventListener(event, func);
  }
};

const track = {
  click: (action, data) => satelliteTrack(CLICK_TRACK_NAME, {action, ...data}),
  change: (action, data) => satelliteTrack(CHANGE_TRACK_NAME, {action, ...data}),
  custom: (action, data) => satelliteTrack(CUSTOM_TRACK_NAME, {action, ...data}),
  view: (action, data) => satelliteTrack(PAGE_VIEW_TRACK_NAME, {action, ...data}),
  screen_view: (data) => mappedSatelliteTrack(SCREEN_VIEW, screenViewTemplate, data),
  sign_up: (data) => mappedSatelliteTrack(SIGN_UP, signUpTemplate, data),
  purchase: (data) => mappedSatelliteTrack(PURCHASE, purchaseTemplate, data),
  begin_checkout: (data) => mappedSatelliteTrack(BEGIN_CHECKOUT, beginCheckoutTemplate, data),
  view_item: (data) => mappedSatelliteTrack(VIEW_ITEM, viewItemTemplate, data),
  view_item_list: (data) => mappedSatelliteTrack(VIEW_ITEM_LIST, viewItemListTemplate, data),
  login: (data) => mappedSatelliteTrack(LOGIN, loginTemplate, data),
  error: (data) => mappedSatelliteTrack(ERROR, errorTemplate, data),
  custom_event: (data) => satelliteTrack(CUSTOM_TRACK_NAME, data),
};

const setPageTrackingInfo = (trackingInfo) => {
  // Avoid unnecessary processing.
  if (!CLIENT || !trackingInfo || Object.keys(trackingInfo).length === 0) {
    return;
  }

  if (!window[DATALAYER_WINDOW_KEY]) {
    window[DATALAYER_WINDOW_KEY] = {};
  }

  const tInfo = window[DATALAYER_WINDOW_KEY][TRACKING_INFO] || {};

  window[DATALAYER_WINDOW_KEY][TRACKING_INFO] = {...tInfo, ...trackingInfo};
};

const getPageTrackingInfo = () => {
  return (CLIENT && window[DATALAYER_WINDOW_KEY]?.[TRACKING_INFO]) || {};
};

export {
  pushDataToDataLayer,
  clearDataOnDataLayer,
  addEventListener,
  removeEventListener,
  track,
  setPageTrackingInfo,
  getPageTrackingInfo,
};
